import React, { useContext, useState } from 'react';
import { ChevronIcon } from 'assets/icons';
import { Button, ButtonSize, ButtonStyle } from 'common/button';
import { NotificationType } from 'common/enums';
import { appActions, AppContext } from 'context';
import { NotificationObject } from 'models/notificationObject';
import { UserController } from 'networking/controllers/user-controller';
import styles from './manage-billing-card.module.scss';

type ManageBillingCardProps = {
  className?: string;
};

// Storage-plan vaults are paid through Stripe Checkout, so the card, invoices
// and Annual-plan cancellation live in Stripe's hosted Customer Portal rather
// than on our own payment method and discount cards (kept for legacy vaults).
const ManageBillingCard: React.FC<ManageBillingCardProps> = ({
  className = '',
}) => {
  const { dispatch } = useContext(AppContext);
  const [opening, setOpening] = useState(false);

  const openPortal = async () => {
    setOpening(true);
    try {
      window.location.href = await UserController.getBillingPortalUrl();
    } catch {
      setOpening(false);
      dispatch({
        type: appActions.NOTIFICATION,
        notification: new NotificationObject({
          show: true,
          title: 'Billing couldn’t be opened',
          message:
            'There’s no billing account for you yet. It’s created when you pay for your first vault.',
          type: NotificationType.Error,
        }),
      });
    }
  };

  return (
    <div className={className}>
      <p className="text__title2__gray800">Billing</p>
      <div className={styles.billingDetails}>
        <p className="text__body__regular__small__gray700">
          Update your card, download invoices and manage Annual plans on Stripe,
          our secure payment provider.
        </p>
        <Button
          className={styles.manageButton}
          buttonStyle={ButtonStyle.LinkColor}
          buttonSize={ButtonSize.Small}
          disabled={opening}
          onClick={openPortal}
        >
          {opening ? 'Opening…' : 'Manage billing'}
          <ChevronIcon className={styles.chevronIcon} />
        </Button>
      </div>
    </div>
  );
};

export { ManageBillingCard };
